import React, { Fragment, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import SweetAlert from 'react-bootstrap-sweetalert';
import { ConstantPermissions } from 'contexts/useConstant';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { Toasty, useToasty } from 'hooks/Toasty';
import { wsUpdate, wsFindBy, wsCreate } from 'services/WService';
import WorkDays from './WorkDays';

const useStyles = makeStyles(styles);

export default function WorkingDay() {
  const [notify, showNotify] = useToasty();
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  // #region estilos de tabs
  const claseStyleTab = useStyleTabs();
  const themeTab = useTheme();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  // #endregion

  const [works, setWorks] = useState([]);
  const [filters, setFilters] = useState({});

  async function listWorks(filters) {
    setDataLoading(true);
    let response = await wsFindBy('ordm/work-day', filters);
    setDataLoading(false);
    if (response.success) {
      setWorks(response.data);
      setFilters(filters);
    }
  }

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirmChange({ id, title, seller, data, entity }) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Desea ${title} la jornada?`}
        onConfirm={() => {
          updateStatusWorkDay(entity, id, data);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {`!Está seguro de ${title} la jornada de \n ${seller}!`}
      </SweetAlert>,
    );
  }

  async function updateStatusWorkDay(entity, id = null, data) {
    let response;
    if (id) {
      setDataLoading(true);
      response = await wsUpdate(entity, id, data);
      setDataLoading(false);
    } else {
      setDataLoading(true);
      response = await wsCreate(entity, data);
      setDataLoading(false);
    }

    if (response.success) {
      showNotify(response.message);
      listWorks(filters);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      <div className={claseStyleTab.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="secondary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="tabs"
          >
            <Tab label="Jornadas actuales" {...indexTab(0)} />
            <Tab label="Jornadas no cerradas" {...indexTab(1)} />
          </Tabs>
        </AppBar>

        <SwipeableViews
          axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0}>
            <WorkDays
              // title="Jornadas actuales"
              title={(<>Jornadas actuales {dataLoading && <LoadingSpinner />}</>)}
              type="NR" // NR = Normal
              works={works?.filter((field) => field.days !== 'days')} //filtrar campos
              reload={listWorks}
              confirmChange={confirmChange}
              permissions={{
                destroy: ConstantPermissions.ORDM_WORK_DAYS_DESTROY,
                restore: ConstantPermissions.ORDM_WORK_DAYS_RESTORE,
                init: ConstantPermissions.ORDM_WORK_DAYS_RESTORE,
              }}
            />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <WorkDays
              // title="Jornadas pasadas"
              title={(<>Jornadas pasadas {dataLoading && <LoadingSpinner />}</>)}
              type="NC" //NC = no cerrados
              works={works}
              reload={listWorks}
              confirmChange={confirmChange}
              permissions={{
                destroy: ConstantPermissions.ORDM_WORK_DAYS_DESTROY,
                restore: ConstantPermissions.ORDM_WORK_DAYS_RESTORE,
              }}
            />
          </TabPanel>
        </SwipeableViews>
      </div>
    </Fragment>
  );
}
